import { toast } from "react-toastify";
import Layout from "../../../components/Layout";
import { useMediaQuery } from "@mui/material";
import { httprequest } from "../../../data/api";
import { useEffect, useState } from "react";
import Table from "../../../components/Table/Table";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Icon } from "@iconify/react/dist/iconify.js";
import Button from "../../../components/Button";
import { useNavigate, useParams } from "react-router-dom";
import PageLoader from "../../../components/PageLoader";
import useStyles from "../styles";
import nosearch from "../../../assets/images/no-search.svg";
import NotFounditem from "../../error/NotFound";
import BreadCrumb from "../../../components/BreadCrumb";
import Modal from "../../../components/Modal";

const GET_SESSIONS = "/api/v1/school-plan/session";
const GET_CLASS_GRADES = "/api/v1/session-report/class/";
const CLASSES_ENDPOINT = "/api/v1/class";
const PROMOTE_ENPOINT = "/api/v1/promotion/students";
const PromotionClass = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:600px)");
  const [activeSession, setActiveSession] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [classGrades, setClassGrades] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [isPageFetching, setIsPageFetching] = useState(false);
  const navigate = useNavigate();
  const [classesData, setClassData] = useState({});
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [promoteModal, setPromoteModal] = useState(false);
  const { id } = useParams();
  const [selectedStudents, setSelectedStudents] = useState([]);

  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  const checkRowSelected = (e) => {
    const selectedIds = e.selectedRows.map((row) => row.student_id);
    setSelectedStudents(selectedIds);
    setIsRowSelected(selectedIds.length > 0);
  };

  const handlePromoteModal = () => {
    setPromoteModal(!promoteModal);
  };

  const getClassesId = () => {
    httprequest
      .get(`${CLASSES_ENDPOINT}/${id}`)
      .then((res) => {
        const physicalClasses = res?.data?.data;
        setClassData(physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const handleGetAllClassResult = async (sessionId) => {
    setIsPageFetching(true);
    try {
      const url = sessionId
        ? `${GET_CLASS_GRADES}${id}?session_id=${sessionId}`
        : `${GET_CLASS_GRADES}${id}`;

      const res = await httprequest.get(url);

      setIsPageFetching(false);
      setClassGrades(res?.data?.data);
      setFilteredStudents(res?.data?.data);
    } catch (err) {
      setIsPageFetching(false);
      toast.error(err?.response?.message);
    }
  };

  const handleSessionChange = (e) => {
    const sessionId = e.target.value;
    const selectedSession = allSessions.find(sesh => sesh.id === sessionId);
    setActiveSession(selectedSession);
    handleGetAllClassResult(sessionId);

    // getSessionReport(sessionId, selectedClass);
  };

  const allTerms = Array.from(
    new Map(
      (filteredStudents || [])
        .flatMap((s) => (s.subjects || []))
        .flatMap((subj) => (subj.terms || []))
        .map((term) => [term.id, { id: term.id, name: term.name }])
    ).values()
  );

  const columns = [
    {
      name: "Student Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Student Name</p>}
          {row.first_name} {row.last_name}
        </>
      )
    },

    ...allTerms.map((term) => ({
      name: term.name,
      selector: (row) => {
        const scores = row.subjects
          .flatMap((subject) => subject.terms || [])
          .filter((t) => t.id === term.id)
          .map((t) => t.score);

        const avg =
            scores.length > 0
              ? (scores.reduce((acc, curr) => acc + curr, 0) / scores.length).toFixed(1)
              : "N/A";

        return (
          <>
            {isMobile && <p className="mobile-styling">{term.name}</p>}
            {avg}
          </>
        );
      }
    })),

    {
      name: "Session Average",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Session Average</p>}
          {row?.session_average?.toFixed(1) || "--/--"}
        </>
      )
    },

    {
      name: "Grade",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Grade</p>}
          {row.session_grade || "-//-" }
        </>
      )
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon" onClick={() => navigate(`/reports/studentreport/${row.student_id}`)}>
            <Icon icon="hugeicons:view" />
          </button>
        </div>
      )
    }
  ];

  const handlePromoteStudents = async () => {
    const payload = {
      student_ids: selectedStudents,
      class_id: id,
      session_id: activeSession?.id,
      promotion_status: "promoted"
    };

    try {
      await httprequest.post(PROMOTE_ENPOINT, payload);
      toast.success("Students promoted successfully!");
      setPromoteModal(false);
      handleGetAllClassResult();
    } catch (err) {
      toast.error(err?.response?.data || "Failed to promote students");
    }
  };

  useEffect(() => {
    getAllSessions();
    handleGetAllClassResult();
    getClassesId();
  }, []);

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one="/report/promotion"
              link_one_name="Promotion"
              active={classesData.class_name}
              description="Manage students promotions."
            />
          </div>
          <div className="flex gap-10">
            <div>
              {activeSession?.id && (
                <SelectGroup
                  children={
                    <select
                      defaultValue={activeSession?.id}
                      onChange={handleSessionChange}
                      name="session"
                    >
                      <option value="">---Select---</option>
                      {allSessions?.map((sesh) => {
                        return (
                          <option key={sesh?.id} value={sesh?.id}>
                            {sesh?.session}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
              )}
            </div>
          </div>
        </div>

        <div className="page-content margin-top-30">
          {isPageFetching ? (
            <PageLoader />
          ) : classGrades.length === 0 ? (
            <div className={classes.notfound}>
              <NotFounditem
                img={nosearch}
                title="No Session Report Found"
                subtitle="No Report has been added to the Class."
              />
            </div>
          ) : (
            <>
              <Table
                data={classGrades}
                columns={columns}
                subHeader={false}
                handleRowSelected={checkRowSelected}
                pagination
              />
              {isRowSelected &&
              <div className="flex gap-10 margin-top-30 flex justify-content-center">
                <Button
                  variant="primary"
                  buttonSize="fluid"
                  color="btndefault"
                  buttonName="Promote Selected Student "
                  onClick={handlePromoteModal}
                />
              </div>
              }

            </>

          )}
        </div>
        <Modal
          title="Promote Students?"
          subtitle={`Are you sure you want to promote ${selectedStudents.length} student(s) from ${classesData.class_name}`}
          modalContent={
            <></>
          }
          modalFooter={
            <>
              <Button variant="primary" buttonName="Promote" buttonSize="full" color="btndefault" onClick={handlePromoteStudents} />
            </>
          }
          isopen={promoteModal}
          closeModal={handlePromoteModal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default PromotionClass;
